import { render, staticRenderFns } from "./ToDoFilter.vue?vue&type=template&id=4a242eb8&scoped=true&"
import script from "./ToDoFilter.vue?vue&type=script&lang=js&"
export * from "./ToDoFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a242eb8",
  null
  
)

export default component.exports